
import PropTypes from 'prop-types'
import * as React from 'react'
import { useSelector } from 'react-redux'
// import { Link } from 'react-router-dom'
// import fleetBusinessProfileImage from '../../css/images/Fleet-business-profile.svg'
// import unverifiedFleetImage from "../../css/images/Unverified-fleet.svg";
// import profileImage from '../../css/images/profile-image.svg'
// import verifdone from '../../css/images/verif-done.svg'
import {
  getLoggedInUserFollowersList,
  getLoggedInUserFollowingList,
} from './Driverbuddyprofile/helper.js'

import Toasts from '../../Components/Toasts/Toasts.js'
import NewTabList from './profile/NewTabList.jsx'
import BusinessDetails from '../../Components/BusinessProfile/BusinessDetails.js'
import ErrorHandle from '../../Components/ErrorHandle.js'
import { ProfileApis } from '../../API/Login/ProfileApi.js'
import BusinessDetailsHeader from '../../Components/BusinessProfile/BusinessDetailsHeader.js'
import CreateBusinessProfile from '../../Components/BusinessProfile/CreateBusinessProfile.js'
// import BusinessFeedbackView from '../../Components/BusinessProfile/BusinessFeedbackView.js'

export default function BusinessProfilePage(props) {
  const {
    frProUser
  } = useSelector((state) => state.Users)
  const [toasts, setToasts] = React.useState(null)
  // const [profileImg, setProfileImg] = React.useState('')
  const [businessProfileData, setBusinessProfileData] = React.useState('')

  const getUserBusinessPersonalDetailsView = async () => {
    try {
      const token = {
        id: null,
        fre8ProAccessToken: frProUser?.fre8ProAccessToken,
        userId: frProUser?.userId,
        businessId: null,
        profileId: null,
        operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
        operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
        clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
      };

      // 🔹 Step 1: Get profile
      const resProfile = await ProfileApis.getUserBusinessPersonalDetails(token);
      console.log('-------resProfile---->business', resProfile);
      // setBusinessProfileData()
      const userProfileImgObj = {
        fre8ProAccessToken: frProUser?.fre8ProAccessToken,
        userId: frProUser?.userId,
        businessId: resProfile?.data?.businessId,
        operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
        operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
        clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
      };

      // 🔹 Step 2: Get profile image
      const resImg = await ProfileApis.userBusinessProfileImage(userProfileImgObj);
      console.log('-------resProfile---->business', resImg);

      // 🔹 Step 3: Construct the new user object safely
      const updatedUser = {
        ...resProfile?.data,
        profileImg: resImg?.data?.urlList[0] || '',
      };
      // console.log('--------updatedUser------HeaderContent---->', updatedUser)
      // 🔹 Step 4: Update both local and global state
      // setPersonalDetails(resProfile?.data)
      // setProfileImg(resImg?.data?.urlList[0] || '')
      return setBusinessProfileData(updatedUser);

    } catch (err) {
      console.error('Error in getUserProfile:', err);

      let customMessage = 'User profile details failed';
      let type = 'User Information';
      let color = 'red';
      ErrorHandle(err, setToasts, customMessage, type, color);
    }
  };

  const getFollowersList = () => {
    let followerList = getLoggedInUserFollowersList(frProUser, setToasts)
    console.log('followers list', followerList)
  }
  const getFollowingList = () => {
    let followingList = getLoggedInUserFollowingList(frProUser, setToasts)
    console.log('followers list', followingList)
  }

  React.useEffect(() => {
    getUserBusinessPersonalDetailsView()
    getFollowersList()
    getFollowingList()
  }, []) //eslint-disable-line
  const tabData = {
    ariaOrientation: 'horizontal',
    tabListData: [
      {
        id: 'Profile',
        tabName: 'Business Details',
      },
      {
        id: 'Feedback',
        tabName: 'Feedback',
      },
      {
        id: 'Media',
        tabName: 'Media',
      },
      {
        id: 'Documents',
        tabName: 'Documents',
      },
    ]
  }

  return (
    <>
      <CreateBusinessProfile />
      <main className="main users chart-page p-0" id="skip-target">
        <div className="profile-bg">
          <div className="cover-image">
            <div className="container-fluid"></div>
          </div>

          <div className="container-fluid py-3 ">
            <BusinessDetailsHeader businessProfileData={businessProfileData} />

            <div className="row">
              <div className="col-md-12">
                <NewTabList tabData={tabData} />
              </div>

              <div className="col-md-12">
                <div className="tab-content" id="v-pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="v-Profile"
                    role="tabpanel"
                    aria-labelledby="v-Profile-tab"
                    tabIndex="0"
                  >
                    {businessProfileData ? (
                      <BusinessDetails profileInfo={businessProfileData} />
                    ) : (
                      <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                        <h5 className="fw-bold mb-3">Business summary</h5>
                        <p className="text-muted mb-0">No summary added</p>
                      </div>
                    )}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-Feedback"
                    role="tabpanel"
                    aria-labelledby="v-Feedback-tab"
                    tabIndex="0"
                  >
                    {/* <BusinessFeedbackView /> */}
                    <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                      <h5 className="fw-bold mb-3">
                        Business Feedback
                      </h5>
                      {/* </svg></button> */}
                      <p className="text-muted mb-0">
                        No business Feedback add
                      </p>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-Media"
                    role="tabpanel"
                    aria-labelledby="v-Media-tab"
                    tabIndex="0"
                  >
                    <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                      <h5 className="fw-bold mb-3">
                        Business Media
                      </h5>
                      {/* </svg></button> */}
                      <p className="text-muted mb-0">
                        No business Media add
                      </p>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-Documents"
                    role="tabpanel"
                    aria-labelledby="v-Documents-tab"
                    tabIndex="0"
                  >
                    <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
                      <h5 className="fw-bold mb-3">
                        Business Documents
                      </h5>
                      {/* </svg></button> */}
                      <p className="text-muted mb-0">
                        No business Documents add
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      {toasts && <Toasts toastsList={toasts} />}
    </>
  )
}

BusinessProfilePage.propTypes = {
  loading: PropTypes.bool,
}